import carrierZoneModule from "../carrierZoneModule"

carrierZoneModule.controller("carrierZoneOperationController", ["$scope", "sourceEntity", "entity", "carrierZoneBaseController", ($scope, sourceEntity, entity, carrierZoneBaseController)=> {
    carrierZoneBaseController("carrier-zone-operation", $scope, sourceEntity, entity)
}])